module.exports = __webpack_public_path__ + "static/media/melissa4.6698bdba.jpg";